/**
 * Map between countries and its spoken language
 * @type {{COUNTRY_CODE: LANGUAGE_CODE}}
 */
export const COUNTRIES_TO_LANGUAGE_MAP = {
    FR: 'fr',
    ES: 'es',
    MX: 'es',
    IT: 'it',
    DE: 'de',
    NL: 'nl',
    BR: 'pt',
    PT: 'pt',
};
